module.exports = __webpack_public_path__ + "img/retry-npay.6fb61458.svg";